import React, { useState } from "react";
import { Tooltip } from "reactstrap";

export default function TesTooltip({ children, title = 'Sk tes - Tooltip', placement = 'right', target = '', autohide }) {

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggleTooltip = () => {
        setTooltipOpen(!tooltipOpen)
    }
    target = (target||`selectedTooltip${Math.random()}`)

    return (
        <div className="info"  style={{ display: 'inline-flex' }}>
            <div className="text-left"  style={{ paddingRight: '0.625rem', paddingLeft: '0.625rem' }}>
                <i id={target} className="fa fa-info-circle" aria-hidden="true"></i></div>
            <Tooltip placement={placement} className="tes-tooltip" isOpen={tooltipOpen} target={target} toggle={(e) => toggleTooltip()} autohide={autohide}>
                <div className='tes-tooltip-wrapper'>
                    <div className='tes-tooltip-header'>{title}</div>
                    <div className='tes-tooltip-body'>
                        {children}
                    </div>
                </div>
            </Tooltip>
        </div>
    );
}
